import _asyncToGenerator from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b784a50e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "dialog-footer"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("确定");

import { ref, watch } from 'vue';
import i18n from '@/i18n';
import { ElMessage } from 'element-plus';
import { getPedigreeList } from '@/api/pedigree';
import { saveBook } from '@/api/book';
export default {
  props: {
    dialogTitle: {
      type: String,
      default: '',
      required: true
    },
    dialogTableValue: {
      type: Object,
      default: function _default() {}
    }
  },
  emits: ['update:modelValue', 'initBookList'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var formRef = ref(null);
    var form = ref({
      name: '',
      pedigreeId: 0,
      bookNumber: '',
      headerName: '',
      countyNumber: '',
      applyName: '',
      editDate: '',
      config: {}
    });
    var rules = ref({
      name: [{
        required: true,
        message: '请输入谱系名称',
        trigger: 'blur'
      }],
      pedigreeId: [{
        required: true,
        message: '请选择所属分类',
        trigger: 'blur'
      }],
      headerName: [{
        required: true,
        message: '请输入姓氏',
        trigger: 'blur'
      }]
    });
    var pedigreeList = ref([]);

    var initPedigreeList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPedigreeList();

              case 2:
                res = _context.sent;
                pedigreeList.value = res;
                form.value.categoryId = res[0].id;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initPedigreeList() {
        return _ref2.apply(this, arguments);
      };
    }();

    initPedigreeList();
    watch(function () {
      return props.dialogTableValue;
    }, function () {
      form.value = props.dialogTableValue;
    }, {
      deep: true,
      immediate: true
    });

    var handleClose = function handleClose() {
      emits('update:modelValue', false);
    };

    var hanleConfirm = function hanleConfirm() {
      formRef.value.validate( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var res, data;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 12;
                    break;
                  }

                  res = form.value;
                  data = {
                    head: [],
                    main: {
                      catalogue: [],
                      pedigree: []
                    },
                    appendix: []
                  };
                  res.config = {};
                  res.data = data;
                  _context2.next = 7;
                  return saveBook(res);

                case 7:
                  ElMessage({
                    message: i18n.global.t('message.updeteSuccess'),
                    type: 'success'
                  });
                  emits('initBookList');
                  handleClose();
                  _context2.next = 14;
                  break;

                case 12:
                  console.log('error submit!');
                  return _context2.abrupt("return", false);

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    };

    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": _ctx.dialogVisible,
        title: __props.dialogTitle,
        width: "30%",
        onClose: handleClose
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
            onClick: handleClose
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: hanleConfirm
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            "label-width": "80px",
            rules: rules.value
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: "主题名",
                prop: "name"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: form.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return form.value.name = $event;
                    })
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "所属谱系",
                prop: "pedigreeId"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: form.value.pedigreeId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return form.value.pedigreeId = $event;
                    }),
                    placeholder: "请选择所属谱系"
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedigreeList.value, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "卷号",
                prop: "bookNumber"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: form.value.bookNumber,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return form.value.bookNumber = $event;
                    })
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "页眉名称",
                prop: "headerName"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: form.value.headerName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return form.value.headerName = $event;
                    })
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "郡望堂号",
                prop: "countyNumber"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: form.value.countyNumber,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                      return form.value.countyNumber = $event;
                    })
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "编者",
                prop: "applyName"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: form.value.applyName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                      return form.value.applyName = $event;
                    })
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "编修日期",
                prop: "editDate"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: form.value.editDate,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                      return form.value.editDate = $event;
                    })
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "起始页码",
                prop: "config"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: form.value.pageBegin,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                      return form.value.pageBegin = $event;
                    })
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["model", "rules"])];
        }),
        _: 1
      }, 8, ["model-value", "title"]);
    };
  }
};